import React from "react";
import { Route, Switch } from "react-router-dom";

import Documents from "./views/Documents";
import PreviewDocument from "./views/Documents/Preview";
import Search from "./views/Search";
import DocumentsOld from "./views/DocumentsOld";
import Confidentiality from "./views/Confidentiality";
import About from "./views/About";

export const renderRoutes = (routes = []) => (
  <Switch>
    {routes.map((route, key) => {
      const Component = route.component;

      return (
        <Route
          key={key}
          path={route.layout + route.path}
          exact={route.exact}
          render={(props) => <Component {...props} />}
        />
      );
    })}
  </Switch>
);

var routes = [
  {
    exact: true,
    path: "/",
    name: "Home Page",
    icon: "tim-icons icon-bank",
    component: Documents,
    layout: "",
  },
  {
    exact: true,
    path: "/documents/:layouts?",
    name: "Last News",
    icon: "tim-icons icon-bank",
    component: Documents,
    layout: "",
  },
  {
    exact: true,
    path: "/document/:publicId?",
    name: "Preview Document",
    icon: "tim-icons icon-bank",
    component: PreviewDocument,
    layout: "",
  },
  {
    exact: true,
    path: "/search/:issuer?",
    name: "Search",
    icon: "tim-icons icon-bank",
    component: Search,
    layout: "",
  },
  {
    exact: true,
    path: "/old-documents/:issuer?",
    name: "Last News",
    icon: "tim-icons icon-bank",
    component: DocumentsOld,
    layout: "",
  },
  {
    exact: true,
    path: "/confidentiality/",
    name: "Confidentiality",
    icon: "tim-icons icon-bank",
    component: Confidentiality,
    layout: "",
  },
  {
    exact: true,
    path: "/about/",
    name: "About",
    icon: "tim-icons icon-bank",
    component: About,
    layout: "",
  },
];

export default routes;